import axios, { config } from '..';
import {
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILED,
  CLEAR_PAYMENTS,
} from '../../actionTypes';

export default () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_PAYMENTS });

    const response = await axios.get('/payouts/providers/all', config);

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: FETCH_PAYMENTS_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: FETCH_PAYMENTS_FAILED, error });
  }
};
